import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import { useEffect, useState } from "react";

interface IInputsCycle {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  onBlurHandler: (event: any) => void
}

function InputsCycle(props: IInputsCycle) {
  const [totalCyclesPerYear, setTotalCyclesPerYear] = useState<number>(0);

  const { errors, register, watch, onBlurHandler } = props;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const watchCycleFields: { [key: string]: string | number } = {
    cyclesPerDay: watch("cyclesPerDay"),
    cyclesDaysPerMonth: watch("cyclesDaysPerMonth"),
  };

  useEffect(() => {
    let sum = 1;

    for (const key in watchCycleFields) {
      if (watchCycleFields.hasOwnProperty(key) && !key.includes("Duration")) {
        sum *= parseInt(watchCycleFields[key] as string);
      }
    }
    setTotalCyclesPerYear(sum);
  }, [watchCycleFields]);

  return (
    <div className="d-flex">
      <div className="mr-25 d-flex  align-items-center">
        <div className="d-flex" style={{ flexDirection: "column" }}>
          <div className="d-flex">
            <input
              type="number"
              step="any"
              placeholder="1"
              defaultValue={1}
              className={errors.cyclesPerDay ? "input-error" : ""}
              {...register("cyclesPerDay", {
                required: true,
                min: 0.01,
                max: 99999,
                valueAsNumber: true,
                onBlur: onBlurHandler
              })}
            />
            <p className="ml-5" style={{ marginBottom: "0px" }}>
              Avg. Cycles / Day
            </p>
          </div>
          <small className="input-small-text">0.01 - 99999 cycles</small>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center mr-25">
        <p style={{ fontSize: "40px" }}>&times;</p>
      </div>
      <div className="mr-25 d-flex  align-items-center">
        <div className="d-flex" style={{ flexDirection: "column" }}>
          <div className="d-flex">
            <input
              type="number"
              step="any"
              placeholder="20"
              defaultValue={20}
              className={errors.cyclesDaysPerMonth ? "input-error" : ""}
              {...register("cyclesDaysPerMonth", {
                required: true,
                min: 1,
                max: 31,
                valueAsNumber: true,
                onBlur: onBlurHandler
              })}
            />
            <p className="ml-5" style={{ marginBottom: "0px" }}>
              Avg. Days / Month
            </p>
          </div>
          <small className="input-small-text">1 - 31 days</small>
        </div>
      </div>
      <div className="text-center">
        <p style={{ fontSize: "40px" }}>&#61;</p>
      </div>
      <div className="text-center">
        <p
          style={{
            fontSize: "40px",
            lineHeight: "initial",
            marginBottom: "0px",
          }}
        >
          {totalCyclesPerYear ? totalCyclesPerYear : "00"}
        </p>
        <p
          style={{
            fontSize: "25px",
            lineHeight: "initial",
            marginBottom: "0px",
          }}
        >
          Cycles per Month
        </p>
      </div>
    </div>
  );
}

export default InputsCycle;
